import constantFactory from "@gaoding/constant-factory";

export const {
  MATERIAL_DOWNLOAD_STATUS,
  MATERIAL_DOWNLOAD_STATUS_LIST,
  MATERIAL_DOWNLOAD_STATUS_MAP,
  MATERIAL_DOWNLOAD_STATUS_ITEM_MAP,
} = constantFactory("MATERIAL_DOWNLOAD_STATUS", [
  {
    key: "pending",
    label: "文件获取中...",
    value: 1,
  },
  {
    key: "completed",
    label: "已完成",
    value: 2,
  },
  {
    key: "failure",
    label: "文件获取失败",
    value: 3,
  },
]);
